import { render } from "./DriverIcon.vue?vue&type=template&id=3f97cc5c"
import script from "./DriverIcon.vue?vue&type=script&lang=js"
export * from "./DriverIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__